import {
    Container, Grid,
    Paper, Typography
} from '@material-ui/core';
import React from 'react';
import { globalStyles } from '../../../assets/globalStyles';
import { NetzereignisseActionheader } from './actionheader';
import { NetzereignisseEdit } from './edit';
import { NetzereignisseGrid } from './grid';
import { NetzereignisseKonfig } from './konfig';
import { useStyles } from './netzereignisseStyles';

export const Netzereignisse = (): JSX.Element => {

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };


    return (
        <React.Fragment>
            <Container maxWidth={false} style={{ marginTop: "10px" }}>
                <Grid container md={12} spacing={2} style={{ marginBottom: "10px" }}>
                    <Grid item md={3} />
                    <Grid item md={6}>
                        <Typography color="primary" variant="h5">
                            Netzereignisse Verwaltung
                        </Typography>
                    </Grid>
                </Grid>
                <NetzereignisseKonfig />
            </Container>
            <NetzereignisseEdit />
            <Paper className={classes.paper} style={{ marginLeft: "24px", marginRight: "24px" }}>
                <Grid container spacing={2} style={{ marginBottom: "20px", padding: "0px" }}>
                    <Grid item md={6} >
                        <Typography color="primary" variant="h6" className={classes.typoH6Style} style={{ marginLeft: "20px" }} >
                            Netzereignisse Übersicht
                        </Typography>
                    </Grid>
                    <Grid item md={3} />
                    <NetzereignisseActionheader />
                    <NetzereignisseGrid />
                </Grid>
            </Paper>
        </React.Fragment>
    )
}
